import type { ProjectDto } from '@flowqa/shared';

type UploadProjectOption = ProjectDto;

type PlanProjectOption = {
  id: string;
  lockReason: string | null;
  locked: boolean;
};

const buildExecutionRunsUploadProjectOptions = ({
  planProjectOptions,
  projectOptions,
}: {
  planProjectOptions: PlanProjectOption[];
  projectOptions: UploadProjectOption[];
}): Array<UploadProjectOption & { lockReason: string | null; locked: boolean }> => {
  return projectOptions.map((project) => {
    const projectStatus = planProjectOptions.find((candidate) => candidate.id === project.id);
    return {
      ...project,
      locked: projectStatus?.locked ?? false,
      lockReason: projectStatus?.lockReason ?? null,
    };
  });
};

export { buildExecutionRunsUploadProjectOptions };
